/** Drop a response when a newer request for the same slot has already started. */
export function createLatestGuard() {
  let current = 0
  return {
    begin(): number {
      current += 1
      return current
    },
    isCurrent(token: number): boolean {
      return token === current
    },
  }
}
